import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { Redirect } from 'react-router-dom';

import { LuPlus } from "react-icons/lu";

import Departments from "../pages/Departments";
import RiskLevels from "../pages/RiskLevels";

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';



import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";


import AdminOverlay from "../components/Admin/AdminOverlay";

import AdminTable from "../components/Admin/AdminTable";



import { getUsers, createUser, updateUser, resetEditUserOverlay, resetAdminError } from "../store/actions/adminActions";

function Users(props) {

    const { token, users, getUsersFN, createUserFN, updateUserFN, resetEditUserOverlayFN, edit_user_overlay, error_message, resetAdminErrorFN, created, departments } = props;




    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [editinguser, setEditingUser] = useState(null);

    const [currPage, setcurrPage] = useState("users");





    const openpopup = (data) => {
        ////console.log(data)
        setIsPopupOpen(true);
    }
    const closePopup = () => {
        ////console.log("closePopup");
        resetAdminErrorFN();
        getUsersFN();
        setIsPopupOpen(false);
        setEditingUser(null);

    }

    useEffect(() => {
        resetAdminErrorFN();
        getUsersFN();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    useEffect(() => {

        if (edit_user_overlay) {
            resetEditUserOverlayFN();
            setEditingUser(edit_user_overlay);
            openpopup(true);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [edit_user_overlay]);


    return token ? (
        <div className="flex flex-col w-full h-screen overflow-hidden">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
            <div className="flex flex-row w-full h-full overflow-hidden"> {/* Prevent horizontal scrolling */}
                <Sidebar className="fixed top-0 left-0 h-full pt-[64px] z-0" /> {/* Adjust the top to match TopBar height */}
                <div className="flex flex-col w-full p-4 overflow-auto"> {/* Adjust the margin-left to match Sidebar width */}
                    {currPage === "users" && (
                        <>
                            <div className="flex justify-start items-center ml-8 space-x-8">
                                <button
                                    onClick={() => setcurrPage("users")}
                                    className={`pb-2 text-sm font-medium transition-colors duration-200 ${currPage === "users"
                                            ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                                            : "text-gray-500 hover:text-[#3b3b3b]"
                                        }`}
                                >
                                    Users
                                </button>

                                <button
                                    onClick={() => setcurrPage("levels")}
                                    className={`pb-2 text-sm font-medium transition-colors duration-200 ${currPage === "levels"
                                            ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                                            : "text-gray-500 hover:text-[#3b3b3b]"
                                        }`}
                                >
                                    Levels
                                </button>

                                <button
                                    onClick={() => setcurrPage("departments")}
                                    className={`pb-2 text-sm font-medium transition-colors duration-200 ${currPage === "departments"
                                            ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                                            : "text-gray-500 hover:text-[#3b3b3b]"
                                        }`}
                                >
                                    Departments
                                </button>
                            </div>


                            <div className="h-full w-full mt-4">
                                <div className="flex flex-col gap-2">
                                    <AdminTable data={users} openpopup={openpopup} />

                                    <div className="flex justify-end pr-20"> {}
                                        <button
                                            className="flex items-center justify-center gap-2 pt-2 pb-2 h-10 text-l bg-[#F8F8F8] text-black transition duration-200 rounded-[5px] px-5 hover:bg-opacity-70 shadow-md border border-gray-300 hover:shadow-lg hover:bg-[#F0F0F2]"
                                            onClick={() => openpopup(true)}
                                        >
                                            <LuPlus className="ml-[-10px] w-5 h-5" />
                                            <span>User</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                    </>
                    )}

                    {currPage === "levels" && (
                        <>
                            <div className="flex justify-start items-center ml-8 space-x-8">
                                <button
                                    onClick={() => setcurrPage("users")}
                                    className={`pb-2 text-sm font-medium transition-colors duration-200 ${currPage === "users"
                                            ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                                            : "text-gray-500 hover:text-[#3b3b3b]"
                                        }`}
                                >
                                    Users
                                </button>

                                <button
                                    onClick={() => setcurrPage("levels")}
                                    className={`pb-2 text-sm font-medium transition-colors duration-200 ${currPage === "levels"
                                            ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                                            : "text-gray-500 hover:text-[#3b3b3b]"
                                        }`}
                                >
                                    Levels
                                </button>

                                <button
                                    onClick={() => setcurrPage("departments")}
                                    className={`pb-2 text-sm font-medium transition-colors duration-200 ${currPage === "departments"
                                            ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                                            : "text-gray-500 hover:text-[#3b3b3b]"
                                        }`}
                                >
                                    Departments
                                </button>
                            </div>

                            <RiskLevels></RiskLevels>

                        </>
                    )}
                    {currPage === "departments" && (
                        <>
                            <div className="flex justify-start items-center ml-8 space-x-8">
                                <button
                                    onClick={() => setcurrPage("users")}
                                    className={`pb-2 text-sm font-medium transition-colors duration-200 ${currPage === "users"
                                            ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                                            : "text-gray-500 hover:text-[#3b3b3b]"
                                        }`}
                                >
                                    Users
                                </button>

                                <button
                                    onClick={() => setcurrPage("levels")}
                                    className={`pb-2 text-sm font-medium transition-colors duration-200 ${currPage === "levels"
                                            ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                                            : "text-gray-500 hover:text-[#3b3b3b]"
                                        }`}
                                >
                                    Levels
                                </button>

                                <button
                                    onClick={() => setcurrPage("departments")}
                                    className={`pb-2 text-sm font-medium transition-colors duration-200 ${currPage === "departments"
                                            ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                                            : "text-gray-500 hover:text-[#3b3b3b]"
                                        }`}
                                >
                                    Departments
                                </button>
                            </div>

                            <Departments></Departments>
                        </>
                    )}
                   
                </div>
            </div>





            <Popup
                open={isPopupOpen}
                onClose={closePopup}
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
            >
                <AdminOverlay departments={departments} created={created} resetAdminErrorFN={resetAdminErrorFN} error_message={error_message} closePopup={closePopup} mode={editinguser ? "edit" : "create"} user={users && editinguser ? users.find(user => user.user_id === editinguser) : null} doit={editinguser ? updateUserFN : createUserFN} />
            </Popup>


        </div>
    ) : <Redirect to="/login" />;

}

const mapStateToProps = (state) => {
    return {

        token: state.auth.token,
        users: state.admin.admin_users,
        edit_user_overlay: state.admin.edit_user_overlay,
        error_message: state.admin.error_message,
        created: state.admin.created,
        departments: state.department.departments,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        getUsersFN: () => dispatch(getUsers()),
        createUserFN: (user) => dispatch(createUser(user)),
        updateUserFN: (user) => dispatch(updateUser(user)),
        resetEditUserOverlayFN: () => dispatch(resetEditUserOverlay()),
        resetAdminErrorFN: () => dispatch(resetAdminError()),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Users);
